/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import {getUserInfo} from "../api/user";
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    let menus = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'li-icon-xiangmuguanli',
          menuname: '药品管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: 'icon-cus-manage',
              menuname: '药品管理',
              hasThird: 'N',
              url: 'drug/drugs',
              menus: null
            },
          ]
        },
      ],
      msg: 'success'
    }
    getUserInfo({}).then(res => {
      if (res.resultCode.code !== '00000') {
        this.$message({
          type: 'info',
          message: res.resultCode.cnMsg
        })
      } else {
        if(!res.result.isAdmin){
          menus = {
            success: true,
            data: [
              {
                menuid: 2,
                icon: 'li-icon-xiangmuguanli',
                menuname: '药/械管理',
                hasThird: null,
                url: null,
                menus: [
                  {
                    menuid: 43,
                    icon: 'icon-cat-skuQuery',
                    menuname: '产品管理',
                    hasThird: 'N',
                    url: 'product/productManage',
                    menus: null
                  },
                ]
              },
            ],
            msg: 'success'
          }
        }
        localStorage.setItem('user',JSON.stringify(res.result))
        this.allmenu = menus.data
        // 监听
        this.$root.Bus.$on('toggle', value => {
          this.collapsed = !value
        })
      }
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 60px 0px;
}
.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue